/* ==========================================================================
   LWL — Koleksiyon sayfası iyileştirmeleri (v1.1)
   - Masaüstü: kartın üzerine gelince bedenler → tıklayınca sepete ekler,
     sepet çekmecesini açar (tükenen bedenler üstü çizili)
   - Mobil: kart içinde o rengin fotoğrafları parmakla kaydırılır;
     ilk kart görününce 2. fotoğrafa doğru kayıp geri döner (ipucu)
   - "Bu Kategoride En Çok Satanlar" şeridi (veri: ?view=lwl-top10)
   - Mobil/tablet "Sırala | Filtrele" yapışkan çubuğu + sıralama paneli
   Veri kaynağı: snippets/lwl-card-data.liquid (her kartın yanındaki JSON)
   ========================================================================== */
(function () {
	'use strict';

	if (window.__lwlCollection) return;
	window.__lwlCollection = true;

	var MQ_TOUCH = window.matchMedia('(hover: none), (max-width: 767.98px)');
	var MQ_HOVER = window.matchMedia('(hover: hover) and (pointer: fine)');
	var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	function $$(sel, root) {
		return Array.prototype.slice.call((root || document).querySelectorAll(sel));
	}

	function debounce(fn, ms) {
		var t;
		return function () {
			var args = arguments, ctx = this;
			clearTimeout(t);
			t = setTimeout(function () { fn.apply(ctx, args); }, ms);
		};
	}

	function routeRoot() {
		var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
		return r || '/';
	}

	function esc(str) {
		return String(str == null ? '' : str)
			.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
	}

	function imgUrl(base, w) {
		return base + (base.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
	}

	/* ------------------------------------------------------------------
	   Sepete ekleme → temanın sepetini yenile → sepet çekmecesini aç
	   ------------------------------------------------------------------ */
	function addToCart(variantId) {
		return fetch(routeRoot() + 'cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
				'X-Requested-With': 'XMLHttpRequest'
			},
			body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
		})
			.then(function (res) {
				return res.json().then(function (data) {
					if (!res.ok) {
						throw new Error((data && (data.description || data.message)) || 'Ürün sepete eklenemedi.');
					}
					return data;
				});
			})
			.then(function () {
				var tc = window.themeCore;
				var refresh = tc && tc.CartApi && typeof tc.CartApi.makeRequest === 'function'
					? tc.CartApi.makeRequest(tc.CartApi.actions.GET_CART)
					: null;
				return Promise.resolve(refresh).then(function () {
					if (tc && tc.EventBus) {
						tc.EventBus.emit('cart:drawer:open');
					} else {
						window.location.href = routeRoot() + 'cart';
					}
				});
			});
	}

	document.addEventListener('click', function (e) {
		var btn = e.target.closest && e.target.closest('[data-lwl-add]');
		if (!btn || btn.closest('[data-lwl-upsell]')) return; // sepet önerileri kendi betiğiyle çalışır
		e.preventDefault();
		e.stopPropagation();
		if (btn.disabled || btn.classList.contains('is-loading')) return;

		var box = btn.closest('.lwl-qs');
		var msg = box && box.querySelector('.lwl-qs__msg');
		if (msg) msg.textContent = '';
		btn.classList.add('is-loading');

		addToCart(btn.getAttribute('data-lwl-add'))
			.then(function () {
				btn.classList.remove('is-loading');
				btn.classList.add('is-added');
				setTimeout(function () { btn.classList.remove('is-added'); }, 1600);
			})
			.catch(function (err) {
				btn.classList.remove('is-loading');
				if (msg) msg.textContent = (err && err.message) || 'Ürün sepete eklenemedi.';
			});
	}, true);

	/* ------------------------------------------------------------------
	   Kartlar
	   ------------------------------------------------------------------ */
	var peekPlanned = false;

	function buildSizes(main, variants) {
		var box = document.createElement('div');
		box.className = 'lwl-qs';
		var html;

		if (variants.length === 1) {
			var v = variants[0];
			html = '<button type="button" class="lwl-qs__single" data-lwl-add="' + v.id + '"' +
				(v.a ? '' : ' disabled') + '>' + (v.a ? 'Sepete Ekle' : 'Tükendi') + '</button>';
		} else {
			html = '<p class="lwl-qs__title">Hızlı Ekle</p><div class="lwl-qs__grid">' +
				variants.map(function (x) {
					return '<button type="button" class="lwl-qs__btn" data-lwl-add="' + x.id + '"' +
						(x.a ? '' : ' disabled') +
						' aria-label="' + esc(x.l) + (x.a ? ' — sepete ekle' : ' — tükendi') + '">' +
						esc(x.l) + '</button>';
				}).join('') + '</div>';
		}

		box.innerHTML = html + '<p class="lwl-qs__msg" role="status" aria-live="polite"></p>';
		main.appendChild(box);
	}

	/* --- Kaydırma fotoğrafları: hafıza dostu yükleme ---------------------
	   Telefonlarda yüzlerce fotoğraf aynı anda hafızada tutulursa tarayıcı
	   sekmeyi kapatabilir. Bu yüzden:
	   - kart ekrana yaklaşınca yalnızca 2. fotoğraf yüklenir,
	   - müşteri kaydırdıkça bir sonraki fotoğraf yüklenir,
	   - kart ekrandan çok uzaklaşınca (≈3 ekran) fotoğraflar bırakılır,
	     geri gelince yeniden yüklenir. */
	var nearIO = null;
	var farIO = null;

	function slideLoad(st, upto) {
		for (var i = 0; i < st.imgs.length && i <= upto; i++) {
			var img = st.imgs[i];
			if (!img.getAttribute('src')) {
				img.srcset = img.getAttribute('data-srcset');
				img.src = img.getAttribute('data-src');
				img.alt = img.getAttribute('data-alt') || '';
			}
		}
		if (upto > st.loadedUpto) st.loadedUpto = upto;
	}

	function slideUnload(st) {
		st.imgs.forEach(function (img) {
			if (img.getAttribute('src')) {
				img.removeAttribute('srcset');
				img.removeAttribute('src');
				img.alt = '';
			}
		});
	}

	function observers() {
		if (nearIO || !('IntersectionObserver' in window)) return;
		nearIO = new IntersectionObserver(function (entries) {
			entries.forEach(function (e) {
				var st = e.target.__lwlSlides;
				if (st && e.isIntersecting) slideLoad(st, Math.max(0, st.current));
			});
		}, { rootMargin: '300px 0px' });
		farIO = new IntersectionObserver(function (entries) {
			entries.forEach(function (e) {
				var st = e.target.__lwlSlides;
				if (st && !e.isIntersecting) slideUnload(st);
			});
		}, { rootMargin: '2500px 0px' });
	}

	function buildSlides(card, main, link, imgs) {
		var titleEl = card.querySelector('.product-card__title');
		var alt = titleEl ? titleEl.textContent.trim() : '';
		var frag = document.createDocumentFragment();
		var st = { imgs: [], current: 0, loadedUpto: -1 };

		imgs.forEach(function (u, i) {
			var slide = document.createElement('div');
			slide.className = 'lwl-slide';
			var img = document.createElement('img');
			img.decoding = 'async';
			img.alt = '';
			img.setAttribute('data-alt', alt + ' — ' + (i + 2) + '. fotoğraf');
			img.sizes = '(max-width: 767px) 50vw, 25vw';
			img.setAttribute('data-srcset', [300, 450, 600].map(function (w) { return imgUrl(u, w) + ' ' + w + 'w'; }).join(', '));
			img.setAttribute('data-src', imgUrl(u, 450));
			slide.appendChild(img);
			frag.appendChild(slide);
			st.imgs.push(img);
		});
		link.appendChild(frag);
		card.classList.add('lwl-has-slides');
		card.__lwlSlides = st;

		var total = imgs.length + 1;
		var dots = document.createElement('div');
		dots.className = 'lwl-dots';
		dots.setAttribute('aria-hidden', 'true');
		for (var i = 0; i < total; i++) {
			var d = document.createElement('span');
			if (i === 0) d.className = 'is-active';
			dots.appendChild(d);
		}
		main.appendChild(dots);

		var ticking = false;
		var current = 0;
		link.addEventListener('scroll', function () {
			if (ticking) return;
			ticking = true;
			requestAnimationFrame(function () {
				ticking = false;
				var w = link.clientWidth || 1;
				var idx = Math.min(total - 1, Math.max(0, Math.round(link.scrollLeft / w)));
				if (link.scrollLeft > 4) card.__lwlSwiped = true;
				// görülen fotoğrafın bir sonrakini önceden yükle
				var ahead = Math.min(st.imgs.length - 1, Math.ceil(link.scrollLeft / w));
				if (ahead > st.loadedUpto || !st.imgs[Math.max(0, ahead)].getAttribute('src')) slideLoad(st, ahead);
				st.current = Math.max(0, ahead);
				if (idx === current) return;
				dots.children[current].classList.remove('is-active');
				dots.children[idx].classList.add('is-active');
				current = idx;
			});
		}, { passive: true });

		observers();
		if (nearIO) {
			nearIO.observe(card);
			farIO.observe(card);
		} else {
			slideLoad(st, st.imgs.length - 1);
		}

		if (!peekPlanned) {
			peekPlanned = true;
			planPeek(card);
		}
	}

	/* İlk kart ekranın ortasına gelince 2. fotoğrafa doğru kayıp geri döner */
	function planPeek(card) {
		if (REDUCED_MOTION || !MQ_TOUCH.matches || !('IntersectionObserver' in window)) return;
		var io = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				if (!entry.isIntersecting || entry.intersectionRatio < 0.6) return;
				io.disconnect();
				setTimeout(function () {
					if (card.__lwlSwiped) return;
					card.classList.add('lwl-peek');
					setTimeout(function () { card.classList.remove('lwl-peek'); }, 1450);
				}, 450);
			});
		}, { threshold: [0.6] });
		io.observe(card);
	}

	function enhanceItem(item) {
		if (item.__lwl) return;
		item.__lwl = true;

		var dataEl = item.querySelector('script.lwl-card-data');
		if (!dataEl) return;
		var data;
		try { data = JSON.parse(dataEl.textContent); } catch (err) { return; }

		var card = item.querySelector('.product-card-new');
		if (!card) return;
		var main = card.querySelector('.product-card__main');
		var link = card.querySelector('a.product-card__image-wrapper-link');

		if (MQ_TOUCH.matches && main && link && data.i && data.i.length &&
			link.querySelectorAll('.product-card__image-wrapper').length === 1) {
			buildSlides(card, main, link, data.i);
		}
		if (MQ_HOVER.matches && main && data.v && data.v.length) {
			buildSizes(main, data.v);
		}
	}

	/* ------------------------------------------------------------------
	   Bu Kategoride En Çok Satanlar
	   ------------------------------------------------------------------ */
	var top10Cache = {};
	var top10Roots = [];

	window.addEventListener('resize', debounce(function () {
		top10Roots = top10Roots.filter(function (r) { return r.isConnected; });
		top10Roots.forEach(function (r) { r.__lwlUpdate(); });
	}, 150));

	function loadTop10(url) {
		if (!top10Cache[url]) {
			top10Cache[url] = fetch(url, { credentials: 'same-origin' }).then(function (r) {
				if (!r.ok) throw new Error('top10');
				return r.text();
			});
		}
		return top10Cache[url];
	}

	function setupArrows(root, track) {
		var prev = root.querySelector('[data-lwl-top10-prev]');
		var next = root.querySelector('[data-lwl-top10-next]');

		function update() {
			var max = track.scrollWidth - track.clientWidth - 2;
			if (prev) prev.disabled = track.scrollLeft <= 2;
			if (next) next.disabled = track.scrollLeft >= max;
			root.classList.toggle('lwl-top10--static', max <= 0);
		}

		function step(dir) {
			var item = track.querySelector('.lwl-top10__item');
			var w = item ? item.getBoundingClientRect().width + 4 : track.clientWidth;
			var perView = Math.max(1, Math.floor((track.clientWidth + 4) / w));
			track.scrollBy({ left: dir * perView * w, behavior: 'smooth' });
		}

		if (prev) prev.addEventListener('click', function () { step(-1); });
		if (next) next.addEventListener('click', function () { step(1); });
		track.addEventListener('scroll', debounce(update, 60), { passive: true });
		root.__lwlUpdate = update;
		top10Roots.push(root);
		update();
	}

	function initTop10(root) {
		if (root.__lwl) return;
		root.__lwl = true;

		var track = root.querySelector('[data-lwl-top10-track]');
		var url = root.getAttribute('data-url');
		var min = parseInt(root.getAttribute('data-min') || '4', 10);
		if (!track) return;

		var ready;
		if (url) {
			ready = loadTop10(url).then(function (html) {
				var tmp = document.createElement('div');
				tmp.innerHTML = html;
				var box = tmp.querySelector('[data-lwl-top10-items]');
				var count = box ? box.querySelectorAll('.lwl-top10__item').length : 0;
				if (count < min) return false;
				track.innerHTML = box.innerHTML;
				track.scrollLeft = 0;
				return true;
			});
		} else {
			ready = Promise.resolve(track.querySelectorAll('.lwl-top10__item').length >= min);
		}

		ready
			.then(function (ok) {
				if (!ok) { root.parentNode && root.parentNode.removeChild(root); return; }
				setupArrows(root, track);
			})
			.catch(function () {
				if (root.parentNode) root.parentNode.removeChild(root);
			});
	}

	/* ------------------------------------------------------------------
	   Sırala | Filtrele çubuğu (mobil/tablet)
	   ------------------------------------------------------------------ */
	var bar = null;

	function countActiveFilters() {
		var n = 0, price = false;
		try {
			new URLSearchParams(window.location.search).forEach(function (value, key) {
				if (key.indexOf('filter.') !== 0) return;
				if (/\.price\.(gte|lte)$/.test(key)) { if (value !== '') price = true; return; }
				n++;
			});
		} catch (err) { /* eski tarayıcı */ }
		return n + (price ? 1 : 0);
	}

	var lastSearch = null;

	function syncFilterCount() {
		if (!bar || window.location.search === lastSearch) return;
		lastSearch = window.location.search;
		var el = bar.querySelector('[data-lwl-filter-count]');
		if (!el) return;
		var n = String(countActiveFilters());
		if (el.textContent !== n) el.textContent = n;
		var hide = n === '0';
		if (el.hidden !== hide) el.hidden = hide;
	}

	var sheet = null;
	var sheetReturnFocus = null;
	var CHECK_SVG = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

	function closeSheet() {
		if (!sheet || !sheet.classList.contains('is-open')) return;
		sheet.classList.remove('is-visible');
		document.documentElement.style.overflow = '';
		setTimeout(function () { sheet.classList.remove('is-open'); }, 280);
		if (sheetReturnFocus) sheetReturnFocus.focus({ preventScroll: true });
	}

	function openSortSheet(trigger) {
		var select = document.querySelector('select[name="sort_by"]');
		if (!select) return;

		if (!sheet) {
			sheet = document.createElement('div');
			sheet.className = 'lwl-sheet';
			sheet.innerHTML =
				'<div class="lwl-sheet__overlay" data-lwl-sheet-close></div>' +
				'<div class="lwl-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="lwlSortTitle">' +
				'<div class="lwl-sheet__handle" aria-hidden="true"></div>' +
				'<div class="lwl-sheet__head"><h2 class="lwl-sheet__title" id="lwlSortTitle">Sırala</h2>' +
				'<button type="button" class="lwl-sheet__close" data-lwl-sheet-close aria-label="Kapat">' +
				'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
				'</button></div>' +
				'<div class="lwl-sheet__list" role="radiogroup" aria-labelledby="lwlSortTitle"></div>' +
				'</div>';
			document.body.appendChild(sheet);

			sheet.addEventListener('click', function (e) {
				if (e.target.closest('[data-lwl-sheet-close]')) { closeSheet(); return; }
				var opt = e.target.closest('[data-lwl-sort]');
				if (!opt) return;
				var sel = document.querySelector('select[name="sort_by"]');
				var value = opt.getAttribute('data-lwl-sort');
				closeSheet();
				if (!sel || sel.value === value) return;
				sel.value = value;
				sel.dispatchEvent(new Event('change', { bubbles: true }));
				if (bar) {
					var y = bar.getBoundingClientRect().top + window.pageYOffset -
						(parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--lwl-header-h')) || 0);
					if (window.pageYOffset > y) window.scrollTo({ top: y, behavior: 'smooth' });
				}
			});

			document.addEventListener('keydown', function (e) {
				if (e.key === 'Escape') closeSheet();
			});
		}

		var list = sheet.querySelector('.lwl-sheet__list');
		list.innerHTML = Array.prototype.map.call(select.options, function (o) {
			var on = o.value === select.value;
			return '<button type="button" class="lwl-sheet__opt" role="radio" aria-checked="' + on + '" data-lwl-sort="' + esc(o.value) + '">' +
				'<span>' + esc(o.textContent.trim()) + '</span>' + CHECK_SVG + '</button>';
		}).join('');

		sheetReturnFocus = trigger || null;
		sheet.classList.add('is-open');
		document.documentElement.style.overflow = 'hidden';
		requestAnimationFrame(function () {
			requestAnimationFrame(function () {
				sheet.classList.add('is-visible');
				var current = list.querySelector('[aria-checked="true"]') || list.firstElementChild;
				if (current) current.focus({ preventScroll: true });
			});
		});
	}

	function initBar() {
		bar = document.querySelector('[data-lwl-plp-bar]');
		if (!bar || bar.__lwl) return;
		bar.__lwl = true;

		var header = document.querySelector('.header-section') || document.querySelector('header');

		function headerHeight() {
			if (!header) return 0;
			var pos = getComputedStyle(header).position;
			if (pos !== 'sticky' && pos !== 'fixed') return 0;
			return Math.round(header.getBoundingClientRect().height);
		}

		function setHeaderVar() {
			document.documentElement.style.setProperty('--lwl-header-h', headerHeight() + 'px');
		}

		setHeaderVar();
		window.addEventListener('resize', debounce(setHeaderVar, 150));

		// çubuğun arka planı = üst menünün arka planı
		try {
			var bgEl = header && (header.querySelector('header') || header.firstElementChild || header);
			var bg = bgEl ? getComputedStyle(bgEl).backgroundColor : '';
			if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') {
				document.documentElement.style.setProperty('--lwl-bar-bg', bg);
			}
		} catch (err) { /* varsayılan beyaz */ }

		// yapıştığında hafif gölge
		if ('IntersectionObserver' in window) {
			var sentinel = document.createElement('div');
			sentinel.setAttribute('aria-hidden', 'true');
			sentinel.style.height = '1px';
			sentinel.style.marginBottom = '-1px';
			bar.parentNode.insertBefore(sentinel, bar);
			new IntersectionObserver(function (entries) {
				bar.classList.toggle('is-stuck', !entries[0].isIntersecting && entries[0].boundingClientRect.top < headerHeight() + 1);
			}, { rootMargin: '-' + (headerHeight() + 1) + 'px 0px 0px 0px', threshold: [0, 1] }).observe(sentinel);
		}

		var filterBtn = bar.querySelector('[data-lwl-filter-open]');
		if (filterBtn) {
			filterBtn.addEventListener('click', function () {
				var opener = document.querySelector('.js-filter-menu-opener');
				if (opener) opener.click();
			});
		}

		var sortBtn = bar.querySelector('[data-lwl-sort-open]');
		if (sortBtn) {
			if (!document.querySelector('select[name="sort_by"]')) {
				sortBtn.hidden = true;
				var sep = bar.querySelector('.lwl-plp-bar__sep');
				if (sep) sep.hidden = true;
			}
			sortBtn.addEventListener('click', function () { openSortSheet(sortBtn); });
		}

		syncFilterCount();
		window.addEventListener('popstate', function () { setTimeout(syncFilterCount, 300); });
	}

	/* ------------------------------------------------------------------
	   Başlat + tema ürünleri yeniden çizdiğinde (filtre, sıralama,
	   sonsuz kaydırma) yeni kartları da iyileştir
	   ------------------------------------------------------------------ */
	function scan(root) {
		$$('.collection__item', root).forEach(enhanceItem);
		$$('[data-lwl-top10]', root).forEach(initTop10);
	}

	function init() {
		scan(document);
		initBar();

		var section = document.querySelector('.js-collection');
		if (section && 'MutationObserver' in window) {
			var rescan = debounce(function () {
				scan(section);
				syncFilterCount();
			}, 80);
			var WATCH = '.collection__item, [data-lwl-top10]';
			new MutationObserver(function (mutations) {
				for (var i = 0; i < mutations.length; i++) {
					var added = mutations[i].addedNodes;
					for (var j = 0; j < added.length; j++) {
						var n = added[j];
						if (n.nodeType === 1 && (n.matches(WATCH) || n.querySelector(WATCH))) {
							rescan();
							return;
						}
					}
				}
			}).observe(section, { childList: true, subtree: true });
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();